import React from 'react';
import Input from '../Input';

interface DatePickerProps {
    label?: string;
    value: Date | null | string;
    onChange: (date: Date | null) => void;
    disabled?: boolean;
    error?: boolean;
    helperText?: string;
    required?: boolean;
    name?: string;
    placeholder?: string;
}

const DatePicker: React.FC<DatePickerProps> = ({
    label,
    value,
    onChange,
    disabled = false,
    error = false,
    helperText = '',
    required = false,
    name,
    placeholder
}) => {

    // Convert Date to YYYY-MM-DD string
    const dateToString = (date: Date | null | string): string => {
        if (!date) return '';
        let d: Date;
        if (typeof date === 'string') {
             d = new Date(date);
        } else {
             d = date;
        }

        if (isNaN(d.getTime())) return '';
        
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const val = e.target.value;
        if (!val) {
            onChange(null);
        } else {
            onChange(new Date(val));
        }
    };

    return (
        <Input
            type="date"
            label={label}
            name={name || ''}
            value={dateToString(value)}
            onChange={handleChange}
            disabled={disabled}
            error={error}
            errorMessage={helperText}
            required={required}
            placeholder={placeholder}
        />
    );
};

export default DatePicker;
